import React, { ChangeEvent, useState } from 'react'
import Text from '../../components/text/Text'
import calendar from '../../assets/icons/blue-calendar.png'
import './ReportStyle.css'
import ReportCalendar from '../../components/reportCalendar/ReportCalendar'
import check from '../../assets/icons/icons-success.png'

import downloadoIcon from '../../assets/icons/icons-download.png'
import amipos from '../../assets/icons/amipos-a-blue.png'

import ModalComponent from '../../components/modal/ModalComponent'
import OutlinedSelect from '../../components/outlinedSelect/OutlinedSelect'
import { getReport } from '../../services/reports'

const ReportScreen = () => {
    const [fromDate, setFromDate] = useState('2025-07-04')
    const [toDate, setToDate] = useState('2025-07-20')

    const [openCalendar, setOpenCalendar] = useState<null | 'from' | 'to'>(null)
    const [showModal, setShowModal] = useState(false)
    const [downloadType, setDownloadType] = useState<'pdf' | 'excel'>('excel')

    const options: any = [
        { id: 'excel', label: 'EXCEL' },
        { id: 'pdf', label: 'PDF' },
    ]
    interface DateBoxProps {
        label: string
        date: string
        onClick: () => void
    }

    const handleFilterTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const selectedOption = options.find(
            (element: any) => element.label === event.target.value
        )
        setDownloadType(selectedOption?.id || options[0].id)
    }

    const reportDownloadModal = () => {
        return (
            <ModalComponent
                show={showModal}
                handleClose={() => setShowModal(false)}
                icon={false}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <img
                        src={check}
                        height={88}
                        width={88}
                        style={{
                            alignSelf: 'center',
                            marginBottom: 26,
                            marginTop: 26,
                        }}
                    />
                    <Text
                        label="Reporte generado exitosamente"
                        fontSize={16}
                        fontFamily="Poppins"
                        fontWeight={400}
                        textAlign={'center'}
                    />
                    <Text
                        label="Reporte generado exitosamente"
                        fontSize={14}
                        fontFamily="Poppins"
                        fontWeight={600}
                        color={'white'}
                    />
                    <div
                        className="report-download-button-modal"
                        onClick={() => setShowModal(false)}
                    >
                        <Text
                            label={'Volver a Reporte de Ventas'}
                            fontSize={14}
                            fontFamily="Montserrat"
                            fontWeight={600}
                            color="white"
                            marginLeft={9}
                        />
                    </div>
                </div>
            </ModalComponent>
        )
    }
    const downlaodFile = async () => {
        if (downloadType) {
            const result = await getReport(fromDate, toDate, downloadType)
            console.log('RESULT', result)
            if (!result.url) {
                alert('Hubo un error al recuperar el reporte')
                return
            }
            window.open(result.url, '_blank', 'noopener,noreferrer')
            setTimeout(() => {
                setShowModal(true)
            }, 500)
        }
    }
    const DateBox = ({ label, date, onClick }: DateBoxProps) => {
        // const formattedDate = new Date(`${date}T00:00:00`).toLocaleDateString(
        //     'es-AR',
        //     {
        //         day: '2-digit',
        //         year: 'numeric',
        //         month: 'short',
        //     }
        // )
        const dateObj = new Date(`${date}T00:00:00`)

        const day = dateObj.toLocaleDateString('es-AR', { day: '2-digit' })
        const month = dateObj
            .toLocaleDateString('es-AR', { month: 'short' })
            .replace('.', '')
            .replace(/^./, (c) => c.toUpperCase()) // primera letra mayúscula
        const year = dateObj.getFullYear()

        const formattedDate = `${month} ${day}, ${year}`
        return (
            <div>
                <Text
                    label={label}
                    fontSize={18}
                    fontFamily="Poppins"
                    fontWeight={400}
                    marginBottom={5}
                />
                <div
                    className="report-date-box"
                    onClick={onClick}
                    style={{ cursor: 'pointer' }}
                >
                    <div
                        className="report-inner-row"
                        style={{ marginRight: 5 }}
                    >
                        <img
                            src={calendar}
                            height={16}
                            width={16}
                            alt="calendar icon"
                        />
                    </div>
                    <Text
                        label={formattedDate}
                        fontSize={16}
                        fontFamily="Poppins"
                        fontWeight={400}
                    />
                </div>
            </div>
        )
    }

    const handleDateSelect = (selectedDate: Date) => {
        const isoDate = selectedDate.toISOString().split('T')[0]
        console.log('AA', isoDate)
        if (openCalendar === 'from') {
            setFromDate(isoDate)
        } else if (openCalendar === 'to') {
            setToDate(isoDate)
        }
        setOpenCalendar(null)
    }

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                <Text
                    label="Reporte de Ventas Comercio"
                    fontSize={20}
                    fontFamily="Poppins"
                    fontWeight={600}
                    marginRight={10}
                />
                <img src={amipos} height={24} width={24} />
            </div>
            <Text
                label={
                    'Este reporte considera únicamente los pagos hechos usando amiPASS.'
                }
                fontSize={20}
                fontFamily="Poppins"
                fontWeight={400}
            />

            <Text
                label="Filtro Fecha:"
                fontSize={18}
                fontFamily="Poppins"
                fontWeight={400}
                marginTop={39}
                marginBottom={15}
            />

            <div className="report-container">
                <DateBox
                    label="Desde"
                    date={fromDate}
                    onClick={() => setOpenCalendar('from')}
                />
                <DateBox
                    label="Hasta"
                    date={toDate}
                    onClick={() => setOpenCalendar('to')}
                />

                {/*  <div className="report-filter-button">
                    <Text
                        label="Filtrar"
                        fontSize={16}
                        fontFamily="Montserrat"
                        fontWeight={600}
                        color="#2699D6"
                    />
                </div> */}
            </div>

            {openCalendar && (
                <div className="calendar-popup">
                    <ReportCalendar
                        initialDate={
                            openCalendar === 'from'
                                ? new Date(`${fromDate}T00:00:00`)
                                : new Date(toDate)
                        }
                        onDateSelect={handleDateSelect}
                        onClose={() => setOpenCalendar(null)}
                    />
                </div>
            )}
            <Text
                label={'Descargar en formato'}
                fontSize={16}
                fontFamily="Montserrat"
                fontWeight={700}
                color="#262626"
                marginTop={39}
                marginBottom={15}
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginRight: 440,
                }}
            >
                <OutlinedSelect
                    options={options}
                    contentStyle={{
                        margin: 0,
                    }}
                    inputStyle={{
                        borderRadius: 4,
                        background: 'var(--Base-White, #FFF)',
                        boxShadow: `
                          0px 0px 0px 2px #D6ECFF,
                          0px 0px 0px 1px #6C8EEF inset
                        `,
                        width: 306,
                        height: 44,
                    }}
                    selectStyle={{
                        margin: '5px 10px 5px 10px',
                    }}
                    onChange={handleFilterTypeChange}
                />
                <div className="report-download-button" onClick={downlaodFile}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <img src={downloadoIcon} height={24} width={24} />
                        <Text
                            label={'Descargar informe'}
                            fontSize={16}
                            fontFamily="Montserrat"
                            fontWeight={600}
                            color="white"
                            marginLeft={9}
                        />
                    </div>
                </div>
            </div>
            {reportDownloadModal()}
        </div>
    )
}

export default ReportScreen
